import { useChatInputStore } from '@/store';
import { openNewChatComposer } from '@/lib/openHomeComposer';
import { blockIfWorkModeDisabled } from '@/lib/workModeAvailability';
import { retainUseCaseDraft } from '@/lib/useCaseDraftHandoff';
import { selectUseCaseModel } from '@/lib/useCaseModelSelection';

/** Prepare a new editable draft. Sending and all paid actions stay in the composer. */
export function openUseCaseDraft(router, example, { preserveThroughSignIn = false } = {}) {
  const prompt = typeof example?.prompt === 'string' ? example.prompt.trim() : '';
  if (!prompt || !['chat', 'work', undefined].includes(example?.mode)) return false;
  if (example.modelSlug != null && (example.modelSlug !== 'arya' || example.mode !== 'chat')) return false;
  const work = example.mode === 'work';
  if (work && blockIfWorkModeDisabled()) return false;
  useChatInputStore.getState().clearPendingAutoSend();
  openNewChatComposer(router, { work });
  // Auto selects the appropriate text/media capability for this new draft.
  useChatInputStore.getState().setSelectedModels([]);
  useChatInputStore.getState().setText(prompt);
  if (preserveThroughSignIn) retainUseCaseDraft(prompt, work ? 'work' : 'chat', example.modelSlug);
  selectUseCaseModel(example.modelSlug);
  return true;
}
